module.exports = __webpack_public_path__ + "img/unload-2-3.f0bf4350.png";